import { BUSINESS_UNIT } from '@/constants/businessUnit'

export const EXTRACT_SUMMARY = {
  CASHBACK: 'cashback',
  POINTS: 'points'
} as const

export type ExtractSummary = (typeof EXTRACT_SUMMARY)[keyof typeof EXTRACT_SUMMARY]

export interface ProgramFeatures {
  extractSummary: ExtractSummary
}

const defaultFeatures: ProgramFeatures = {
  extractSummary: EXTRACT_SUMMARY.POINTS
}

const programFeaturesByBu: Partial<Record<string, Partial<ProgramFeatures>>> = {
  [BUSINESS_UNIT.GB]: { extractSummary: EXTRACT_SUMMARY.CASHBACK }
}

export const getProgramFeatures = (businessUnitValue: string | null | undefined): ProgramFeatures => ({
  ...defaultFeatures,
  ...programFeaturesByBu[businessUnitValue ?? '']
})
